<template>
  <div class="checkmark-crossmark">
    <div class="buttons">
      <IconButton :variant="buttonVariant(false)" @click="setValue(false)" size="medium" shape="round" icon="x-close" />
      <IconButton :variant="buttonVariant(true)" @click="setValue(true)" size="medium" shape="round" icon="check" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import IconButton from './icon-button.vue';

const model = defineModel<boolean | null | undefined>();
const buttonVariant = computed(() => {
  return (value: boolean) => (model.value === value ? 'primary' : 'outline');
});

function setValue(value: boolean) {
  model.value = value;
}
</script>

<style scoped>
.checkmark-crossmark {
  display: flex;
  gap: var(--t-spacing-md);

  justify-content: space-between;
  align-items: center;
}

.buttons {
  display: flex;
  gap: var(--t-spacing-sm);
}
</style>
